<template>
    <div class="create-checklist-config">
        <div class="config-field">
            <label>{{ $t("taskModuleRules.checklistItems") }}</label>
            <div
                v-for="(item, index) in localConfig.items"
                :key="`item-${index}`"
                class="checklist-item"
            >
                <a-input
                    v-model="localConfig.items[index]"
                    :placeholder="$t('taskModuleRules.itemTitle')"
                    @change="emitChange"
                />
                <a-button type="text" size="small" danger @click="removeItem(index)">
                    <i class="material-icons">delete</i>
                </a-button>
            </div>

            <a-button type="dashed" block @click="addItem">
                <i class="material-icons">add</i>
                {{ $t("taskModuleRules.addItem") }}
            </a-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "CreateChecklistConfig",
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localConfig: { items: [] }
        };
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        },

        addItem() {
            this.localConfig.items.push('');
            this.emitChange();
        },

        removeItem(index) {
            this.localConfig.items.splice(index, 1);
            this.emitChange();
        }
    }
};
</script>

<style lang="scss" scoped>
.create-checklist-config {
    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }

        .checklist-item {
            display: flex;
            gap: 8px;
            margin-bottom: 8px;

            .ant-input {
                flex: 1;
            }
        }
    }
}
</style>
